import React, { useContext } from "react";
import AlertContext from "../../../../../../context/AlertContext";
import { SOALearningModule } from "../SOAStudentLearningModuleSection/SOALearningModule";
import SOADashoardSkeleton from "./SOADashoardSkeleton";

export const SOALearningModules = () => {
  const Alert = useContext(AlertContext);
  const data = Alert.dashBoardDetails;
  // console.log("Data:", data);
  if (!Object.keys(data)?.length){    
    return (
      // <div className="SOALearningModulesContainerLoadingSpinner">
        <SOADashoardSkeleton/>
      // </div>
    );
  }

  return (
    <>
      {data &&
        data?.batchDetails?.length > 0 &&
        data?.lpData?.length > 0 &&
        data?.lpData?.map((item) => {
          return <SOALearningModule data={item} key={item.lpId} />;
        })}
    </>
  );
};